module.exports = __webpack_public_path__ + "static/media/software-lightblue-diamond.15f36e5b.svg";